import { type Option } from '@retailer-platform/shared-components/src/tds'
import { MultiselectDropdown } from '@retailer-platform/shared-components/src/tds'
import { type NavMenuHierarchyL2 } from '../../nav-v2/NavMenuHierarchy'
import { useDashIntl } from '../../../../intl/intl.hooks'

interface PermissionDropdownProps {
  tool: NavMenuHierarchyL2
  selectedPermissionSlugs: Set<string>
  handlePermissionSlugsChange: (newSelectedPermissionSlugs: Set<string>) => void
  isChecked: boolean
  roleAssignedPermissionSlugs?: Set<string>
}

export const PermissionDropdown = ({
  tool,
  selectedPermissionSlugs,
  handlePermissionSlugsChange,
  isChecked,
  roleAssignedPermissionSlugs,
}: PermissionDropdownProps) => {
  const dashIntl = useDashIntl()
  const cancelButtonText = dashIntl.formatMessage({ id: 'dashboard.permissions.dropdown.cancel' })

  const dropdownOptions: Option[] = Array.from(tool?.inToolPermissions || []).map(permission => ({
    label: dashIntl.formatMessage({ id: permission.permissionLabelId as any }),
    value: permission.slug,
    disabled: roleAssignedPermissionSlugs && roleAssignedPermissionSlugs.has(permission.slug),
  }))

  const selectedinToolPermissions = (tool?.inToolPermissions || []).filter(permission =>
    selectedPermissionSlugs.has(permission.slug)
  )

  const selectedDropdownValues: Option[] = selectedinToolPermissions.map(permission => ({
    label: permission.slug,
    value: permission.slug,
  }))

  const onDropdownChange = (values: Option[]) => {
    const newSelectedPermissionSlugs = new Set(selectedPermissionSlugs)

    const dropdownOptionsSlugs = dropdownOptions.map(value => value.value)
    const selectedDropdownOptionsSlugs = new Set(values.map(value => value.value))

    dropdownOptionsSlugs.forEach(slug => {
      if (selectedDropdownOptionsSlugs.has(slug)) {
        newSelectedPermissionSlugs.add(slug)
      } else {
        newSelectedPermissionSlugs.delete(slug)
      }
    })

    handlePermissionSlugsChange(newSelectedPermissionSlugs)
  }

  return (
    <>
      {dropdownOptions.length > 0 && (
        <MultiselectDropdown
          options={dropdownOptions}
          value={selectedDropdownValues}
          onChange={onDropdownChange}
          placeholder={dashIntl.formatMessage({
            id: 'dashboard.permissions.dropdown.select',
          })}
          disabled={!isChecked}
          withConfirmation
          compact
          removeButtonText={cancelButtonText}
        />
      )}
    </>
  )
}
